import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/products';

export const findProductsByCompany = async (company) => {
    return await sendFetch(`${BASE_PATH}/all/company/${company}`, GET_OPTIONS);
}

export const findProductsAll = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}

export const createProduct = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editProduct = async (body, id) => {
    return await sendFetch(`${BASE_PATH}/edit/${id}`, POST_OPTIONS, body);
}

export const getExcelProducts = async () => {
    return await sendFetch(`${BASE_PATH}/all/excel`, GET_OPTIONS);
}